import { Box, Toolbar, Typography } from "@mui/material";
import { FC } from "react";
import { styled } from "@mui/material/styles";

const VerticalContainerWrapper = styled(Box)(
  ({ theme }) => `

        max-width: 100%;
         & .MuiTypography-h3{
         color: ${theme.colors.primary.main};
        font-size: ${theme.text.fontSizes.lg};
        font-style: normal;
        font-weight: ${theme.text.fontWeights.regular};
        line-height: normal;
        text-align: center;
        margin: 0 auto;
         }
        & .profileLabel{
          font-size: ${theme.text.fontSizes.md};
          font-style: normal;
          font-weight: ${theme.text.fontWeights.light};
          line-height: normal;
          color: #575859;
          margin-bottom: 1px
        }
          & .profileContentText{
          font-size: ${theme.text.fontSizes.md};
          font-style: normal;
          font-weight: ${theme.text.fontWeights.regular};
          line-height: normal;
          color: #000;
        }
         
  `
);

interface ComponentProps {
  entityTitle?: string;
  entityFields: any[];
  tooltips?: React.ReactNode;
  children?: React.ReactNode;
}

const ProfileVerticalContainer: FC<ComponentProps> = ({
  entityTitle,
  entityFields,
  tooltips,
  children,
}) => {
  return (
    <VerticalContainerWrapper>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography variant="h3">{entityTitle}</Typography>
        <div style={{ marginLeft: "auto" }}>{tooltips}</div>
      </Toolbar>
      {entityFields.length !== 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            padding: "16px",
            mb: 2,
          }}
        >
          {entityFields.map((dataItem, index) => (
            <Box
              key={`field-${index}`}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1px",
                wordWrap: "break-word", // Ensure long text wraps
                overflowWrap: "break-word",
              }}
            >
              <span className="profileLabel">{dataItem?.label}</span>
              <span className="profileContentText">{dataItem?.value}</span>
            </Box>
          ))}
        </Box>
      )}
      <Box sx={{ p: 2.5 }}>{children}</Box>
    </VerticalContainerWrapper>
  );
};

export default ProfileVerticalContainer;
